import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  ChevronLeft,
  Plus,
} from 'react-bootstrap-icons';
import styles from './product_detail_view_mobile.module.css';
import { ActivityIcon, ActivityIconBlue, AIChatIcon2, AtollonIcon, EditIcon, FacebookIcon, GlobeIcon, LinkdinIcon, LockIcon, MessageIcon, MoreIcon, PhoneIcon, PrintIcon, SendIcon, ToolIcon, TrashIcon, TwitterIcon } from '../../../../components/protected/Icons/IconsLib';
import { ActionButton, Avatar, Cell, Column, Content, Dialog, DialogTrigger, Divider, Flex, Grid, Item, Link, Menu, MenuTrigger, Row, TableBody, TableHeader, TableView, TabList, TabPanels, Tabs, ToastQueue, View } from '@adobe/react-spectrum';
import moment from 'moment';
import { invokeFinderApp } from '../../../../utils/NavigationUtils';
import { usePreloadAssets } from '../../../../hooks/UsePreloadAssets';
import { useDependency } from '../../../../contexts/DependencyProvider';
import { DeleteConfirmationDialog } from '../../finder/components/DeleteConfirmationDialog';
import { FPAData } from '../../../../infra/protected/FPA/FPAData';
import { useReefConfig } from '../../../../hooks/UseReefConfig';
import { getDownloadUrl } from '../../../../utils/ImagePathUtils';
import { useTranslation } from 'react-i18next';
import { statusColor } from '../../../../utils/helperUtil';
import { ListItemStatusRequest } from '../../../../services/soap/item/requests/ListItemStatusRequest';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { Key } from '@react-types/shared';
import { Badge, Button } from 'react-bootstrap';
import ComponentRelations from './ComponentRelations';
import { useCategoryColors } from '../../../../hooks/useCategoryColors';
import { ProductStatusDropdown } from './ProductStatusDropdown';
interface IProductDetailViewProps {
  product: any;
  productStatusList: any[];
  onPrint?: (item: any) => void;
  onEdit?: (item: boolean) => void;
  onDelete?: (item: any) => void;
  onTool?: (item: any) => void;
  onAI?: (item: any) => void;
  onCopy?: (item: any) => void;
  onMove?: (item: any) => void;
  selectedItem?: any;
}
const ProductDetailView: React.FC<IProductDetailViewProps> = ({
  product,
  productStatusList,
  onPrint, onEdit, onDelete, onTool, onAI, selectedItem, onCopy, onMove
}) => {
  const { contactSettings } = usePreloadAssets();
  const [employeesData, setEmployeesData] = useState<any>([]);
  const { store, itemService } = useDependency();
  const [result, setResult] = useState<any>([]);
  let [activityStatus, setActivityStatus] = useState('');
  const { t } = useTranslation('products');
  const _t = (key: string) => t(`product_detail.${key}`, { ns: 'products' });
  const _tt = (key: string) => t(`product_common.${key}`, { ns: 'products' });
  const { getProductCategoryColor, getTextColor } = useCategoryColors();


  useEffect(() => {

  }, [product])

  let [isOpen, setOpen] = React.useState(false);

  const { baseUrl, loginInfo } = useReefConfig();
  const getProfileUrl = () => {
    if (result.DOCUMENT && result.DOCUMENT.length > 0) {
      const imageUrl = getDownloadUrl(result.DOCUMENT[0].documentId, baseUrl, store.Server, store.SessionId);
      return imageUrl
    }
    return '/assets/images/avatar--desktop--light@2x.png'
  }

  async function updateActivityStatus(e: any) {
    // let resActivity = await projectService.updateActivity(new UpdateActivityRequest(store.Server, store.SessionId, { ...activityData, customState: e.value }));
    // let status = activityStatusList.find((status: any) => status.id === e.value);
    // if (resActivity.result == 'OK') {
    //   await featureService.checkWorkFlowQueue(new CheckWorkFlowQueueRequest(store.Server, store.SessionId));
    //   ToastQueue.positive(t('status_updated_successfully', { ns: 'layout_components' }), { timeout: 1000 });
    //   dispatch(setSelectedItem({ item: selectedItem ? { ...selectedItem, statusName: status.name, statusColor: statusColor(status.color) } : null, show_context: false }));
    // } else {
    //   ToastQueue.negative(resActivity.EXCEPTION?.message, { timeout: 1000 });
    // }
  }

  let menuItems = [
    { key: 'ai', name: 'AI Chat' },
    { key: 'lock', name: 'Lock' },
    { key: 'copy', name: 'Copy' },
    { key: 'move', name: _t('move') },
    { key: 'copyLink', name: _t('copy_link') },
  ];

  const handlePrintClicked = () => {
    //console.log('handlePrintClicked');
    if (onPrint) {
      onPrint(product);
    }
  };

  const handleEditClicked = () => {
    if (onEdit) {
      onEdit(true);
    }
  };

  const handleDeleteClicked = () => {
    if (onDelete) {
      onDelete(product);
    }
  };

  const handleToolClicked = () => {
    if (onTool) {
      onTool(product);
    }
  };

  const handleAIClicked = () => {
    if (onAI) {
      onAI(product);
    }
  };

  const handleMenuClicked = (key: Key) => {
    if (key === 'copy') {
      if (onCopy) {
        onCopy(product);
      }
    } else if (key === 'move') {
      if (onMove) {
        onMove(product);
      }
    } else if (key === 'copyLink') {
      copyUrl();
    }
  };

  const componentData = Array.isArray(product.COMPONENT)
    ? product.COMPONENT
    : product.COMPONENT
      ? [product.COMPONENT]
      : [];

  const uniqueComponents = Array.from(
    new Map(componentData.map((item: any) => [item.component, item])).values()
  );

  const copyUrl = () => {
    const url = `${window.location.origin}/products?id=${product?.id}`;
    navigator.clipboard.writeText(url);
    ToastQueue.positive(t('link_copied_to_clipboard', { ns: 'layout_components' }), { timeout: 1000 });
  }

  return (
    <Flex width="100%" UNSAFE_style={{ paddingLeft: '10px', paddingRight: '10px' }} direction={'column'}>
      <View UNSAFE_className={styles.header_main}>
        <View UNSAFE_className={styles.header_child}>
          <View UNSAFE_className={styles.frame_parent}>
            <ProductStatusDropdown productStatusArray={productStatusList} selectedStatus={product.status} onStatusChange={updateActivityStatus} />
            <View UNSAFE_className={styles.icon_activity_parent}>
              {/* <ActivityIconBlue size={25} /> */}
              <b title={product?.name} className={styles.activity_name}>
                {product?.name?.length > 55 ? product?.name.substring(0, 55) + '...' : product?.name}
              </b>
            </View>
            {product.manufacturerName &&
              <View UNSAFE_className={styles.folder_name_parent}>
                <View UNSAFE_className={styles.folder_name}>{`${product.manufacturerName}`}</View>
              </View>
            }
          </View>
          {(product.componentCategoryName || product?.refId || product.typeName) &&
            <View UNSAFE_className={styles.tag_parent} marginTop={'27px'}>
              {product?.typeName && (
                <Badge
                  key={'tag1'}
                  style={{ display: "div", alignItems: "center", }}
                  className={styles.greyBadge}
                >
                  <span >{product.typeName}</span>
                </Badge>
              )}
              {product?.refId && (
                <Badge
                  key={'tag2'}
                  style={{ display: "div", alignItems: "center", }}
                  className={styles.greyBadge}
                >
                  <span >{product.refId}</span>
                </Badge>
              )}
              {product?.componentCategoryName && (
                <Badge
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    backgroundColor: getProductCategoryColor(product.componentCategoryName),
                    color: getTextColor(getProductCategoryColor(product.componentCategoryName)),
                  }}
                  bg=""
                  className={styles.purpleBadge}
                >
                  <span>{product.componentCategoryName}</span>
                </Badge>
              )}
            </View>
          }
        </View>
        <View UNSAFE_className={styles.icon_list_parent}>
          <View UNSAFE_className={styles.icon_list_child}>
            <div className={styles.edit_icon} onClick={handleEditClicked}>
              <EditIcon size={32} />
            </div>
            <div className={styles.delete_icon} onClick={handleDeleteClicked}>
              <TrashIcon size={32} />
            </div>
            <MenuTrigger>
              <ActionButton UNSAFE_style={{ border: 'none' }}>...</ActionButton>
              <Menu items={menuItems} onAction={handleMenuClicked}>
                {item => <Item key={item.key}>{item.name}</Item>}
              </Menu>
            </MenuTrigger>
          </View>
        </View>
      </View>
      <View>
        <Tabs aria-label="Product detail" isEmphasized>
          <TabList>
            <Item key="product">{_t('product_detail')}</Item>
          </TabList>
          <TabPanels>
            <Item key="product">
              <Flex direction={'row'} marginTop="size-400">
                <Flex direction="column" gap="size-100" gridArea="detail" width='60%'>
                  <View UNSAFE_className={styles.productMainTitle}>
                    {product.name}
                  </View>

                  <View>
                    <span className={styles.product_code_title}>{_t('product_code')}: </span>
                    <span className={styles.product_code}>{product.refId}</span>
                  </View>

                  <View marginTop="size-100">
                    <p className={styles.product_detail}>
                      {`${product.note && product.note.length > 0 ? product.note : ''}`}
                    </p>
                  </View>
                </Flex>

                <Flex alignItems="center" justifyContent="center" gridArea="image" width='40%'>
                  <div className={styles.img_gray_box}></div>
                </Flex>
              </Flex>
            </Item>
          </TabPanels>
        </Tabs>
      </View>
      <View marginTop={10} UNSAFE_className={styles.greybox_parent}>
        <Flex justifyContent="space-between" alignItems="center" UNSAFE_style={{ width: '100%' }}>
          <View UNSAFE_className={styles.value_header}><b>Prices</b></View>
          <Flex gap="size-100">
            <ActionButton isQuiet aria-label="Add">
              <Plus size={20} />
            </ActionButton>
          </Flex>
        </Flex>
        <View UNSAFE_className={styles.value_wrapper}>
          <View
            UNSAFE_style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '10px',
            }}
          >
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('purchase_price')}:</div>
              <div className={styles.value}>{product.purchasePrice}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('price')}:</div>
              <div className={styles.value}>{product.amount}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('currency')}:</div>
              <div className={styles.value}>{product.currencyName}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('vat')}:</div>
              <div className={styles.value}>{product.vatValue}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('quantity')}:</div>
              <div className={styles.value}>{product.quantity}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('incl_vat')}:</div>
              <div className={styles.value}>{product.amountWithVat}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('units')}:</div>
              <div className={styles.value}>{product.unitsName}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('measure_stocks')}:</div>
              <div className={styles.value}>{product.measureStock}</div>
            </div>
          </View>
        </View>
      </View>
      {componentData.length > 0 && (
        <>
          <View marginTop={10} minHeight={'size-250'} paddingBottom={'100px'}>
            <ComponentRelations data={uniqueComponents || []} />
          </View>
        </>
      )
      }
    </Flex>
  );
};

export default ProductDetailView;
